module.exports = __webpack_public_path__ + "img/icon-13-b.a5b1bcd9.png";